import PrivateLeagueBasicCreateRequestBody from "../../PrivateLeagues/Models/Request/Create/PrivateLeagueBasicCreateModel";

export default class ChallengeCreateModel extends PrivateLeagueBasicCreateRequestBody {
  public type: string = "ONE_VS_ONE";
}
